import React from 'react';

import { Icon, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';
import { Box } from '@betterment/style-closet-react';

import IndividualTaskContainer from './IndividualTaskContainer';

import { trackClick } from '../../../features/track';
import { urlBuilder } from '../../../Shared/urlBuilder';
import { AccountTask } from '../../data';
import { useAccount } from '../AccountProvider';

interface SetUpDirectDepositProps {
  task: AccountTask;
  refetchTasks: () => void;
}

const SetUpDirectDeposit: React.FC<React.PropsWithChildren<SetUpDirectDepositProps>> = ({ task, refetchTasks }) => {
  const { account } = useAccount();

  return (
    <IndividualTaskContainer {...task} onSkip={refetchTasks}>
      <Box mb="6">
        <Icon name="DepositCheck" size="medium" />
      </Box>
      <Text
        as="p"
        css={{
          fontWeight: '700',
          fontSize: 'fontSize.300',
          marginBottom: 'space.200',
          _last: { marginBottom: 'space.0' },
        }}
      >
        Set up direct deposit
      </Text>
      <Text as="p" css={{ marginBottom: 'space.200', _last: { marginBottom: 'space.0' } }}>
        Get the most out of Betterment Checking by setting up direct deposit.
      </Text>
      <SambaAutoLink
        to={urlBuilder.getAppCheckingAccountDirectDeposit.absolute({ accountId: account.id })}
        onClick={() => trackClick({ name: 'GetStartedDirectDeposit', module: 'SetUpDirectDeposit' })}
      >
        Get started
      </SambaAutoLink>
    </IndividualTaskContainer>
  );
};

export default SetUpDirectDeposit;
